import { logs } from '@shoppykey/tools';
import _ from 'lodash';
import { CurrentUser } from './schema/current-user';

export type AccessFn = {
  menuPowerFilter: (router: { powers: string[] }) => boolean;
  menuOrPowerFilter: (router: { powers: string[] }) => boolean;
  powerFilter: (powers: string[]) => boolean;
};

export default function access(initialState: CurrentUser) {
  function print(powers: string[]) {
    if (process.env.BRANCH !== 'main') {
      const userName = initialState?.user?.showName || initialState?.user?.username || '未知';
      logs.warn(`用户 ${userName} 没有 ${powers?.join(',')} 权限`);
    }
  }

  return {
    menuPowerFilter: (router: { powers: string[] }) => {
      const accessible = _.isEmpty(_.difference(router?.powers, initialState?.powers));
      if (!accessible) print(router.powers);
      return accessible;
    },
    menuOrPowerFilter: (router: { powers: string[] }) => {
      const accessible = !_.isEmpty(_.intersection(router.powers, initialState?.powers));
      if (!accessible) print(router.powers);
      return accessible;
    },
    powerFilter: (powers: string[]) => {
      const accessible = _.isEmpty(_.difference(powers, initialState?.powers));
      if (!accessible) {
        print(powers);
        return false;
      }
      return accessible;
    },
  };
}
